// extracted by mini-css-extract-plugin
module.exports = {"container":"PhoneFieldV2_container__xDfpp","select-container":"PhoneFieldV2_select-container__PlTq6","input-container":"PhoneFieldV2_input-container__bCzOc"};